import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { Row, Grid } from "antd";
import { useTrackVisibility } from "react-intersection-observer-hook";
import { WrapGlobeAirFreight } from "@/components/customs/Map/mapGlobeWrapper";

import { useEffect, useState, useRef, memo } from "react";
const { useBreakpoint } = Grid;

function ServiceAirFreightAreaOperationNormal({ our_area_of_operation = {}, active }) {
	const [ref] = useTrackVisibility();
	const screens = useBreakpoint();

	return (
		<Container ref={ref}>
			<Row justify="center">
				<RATypography variant={screens?.md ? "h3" : "h4"} align="center">
					{our_area_of_operation?.title || ""}
				</RATypography>
			</Row>
			<Row justify="center" style={{ padding: "0 16px" }}>
				<RATypography variant="body3" top={screens.xs ? "6px" : "20px"} color="#595959" align="center">
					{our_area_of_operation?.description || ""}
				</RATypography>
			</Row>
			<Row
				justify="center"
				style={{
					overflow: "hidden",
					marginTop: screens?.md ? 40 : 20,
					maxHeight: "60vh",
				}}
			>
				<WrapGlobeAirFreight
					centerAiport={our_area_of_operation?.airport}
					range={our_area_of_operation?.radius_nm}
					routes={our_area_of_operation?.routes}
				/>
			</Row>
		</Container>
	);
}

const ServiceAirFreightAreaOperationSnap = memo(function ServiceAirFreightAreaOperationSnap({
	our_area_of_operation = {},
	active,
}) {
	const [visible, setVisible] = useState(false);
	const [wrapperGlobeHeight, setWrapperGlobeHeight] = useState({
		textHeight: 0,
		globeHeight: 0,
	});
	const screens = useBreakpoint();
	const firstRowRef = useRef(null);
	const secondRowRef = useRef(null);
	useEffect(() => {
		if (active) {
			setVisible(true);
		}
	}, [active]);

	useEffect(() => {
		setWrapperGlobeHeight(
			(prev) => ({
				...prev,
				textHeight: firstRowRef?.current?.clientHeight + secondRowRef?.current?.clientHeight,
				globeHeight:
					window?.innerHeight - firstRowRef.current?.offsetHeight - secondRowRef.current?.offsetHeight || 0,
			}),
			[],
		);
	}, []);

	return (
		<ContainerSnap>
			<div style={{ zIndex: 10 }}>
				<Row justify="center" ref={firstRowRef}>
					<RATypography
						variant={screens?.md ? "h3" : "h4"}
						align="center"
						style={{
							padding: "0 28px",
						}}
					>
						{our_area_of_operation?.title || ""}
					</RATypography>
				</Row>
				<Row
					ref={secondRowRef}
					justify="center"
					style={{
						padding: "0 20px",
						paddingBottom: screens?.md ? 40 : 20,
					}}
				>
					<RATypography variant="body3" top={screens.xs ? "6px" : "20px"} color="#595959" align="center">
						{our_area_of_operation?.description || ""}
					</RATypography>
				</Row>
			</div>
			<GlobeContainer
				justify="center"
				style={{
					overflow: "hidden",
					zIndex: "-1",
				}}
				textHeight={wrapperGlobeHeight.textHeight}
			>
				<WrapGlobeAirFreight
					centerAiport={our_area_of_operation?.airport}
					range={our_area_of_operation?.radius_nm}
					routes={visible ? our_area_of_operation?.routes : []}
					// routes={our_area_of_operation?.routes}
				/>
			</GlobeContainer>
		</ContainerSnap>
	);
});

export { ServiceAirFreightAreaOperationSnap, ServiceAirFreightAreaOperationNormal };

const ContainerSnap = styled.div`
	width: 100%;
	height: 100vh;
	overflow: hidden;
	/* padding-top: 10%; */
	padding-top: 120px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
`;

const GlobeContainer = styled.div`
	position: absolute;
	top: ${({ textHeight }) => textHeight}px;
	@media (max-width: 1600px) {
		top: 50%;
	}
`;

const Container = styled.div`
	width: 100%;
	/* height: 100vh; */
	overflow: hidden;
	padding-top: 10%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
`;
